import { API_BASE_URL } from '../config/api';

/** Turn stored image paths into absolute URLs (required for Capacitor / native WebView). */
export function resolveMediaUrl(url: string | null | undefined): string | null {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  if (!base) return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return trimmed.startsWith('/') ? `${base}${trimmed}` : `${base}/${trimmed}`;
}
